import { styled } from "@tamagui/core";
import * as LibSvg from "react-native-svg";
import { jsx } from "react/jsx-runtime";
const VIEWBOX_BOUNDS = 24,
  STROKE_WIDTH = 2.5,
  Svg = styled(LibSvg.Svg, {
    // This name has an impact on the generated css class name. If you change it, please also update the css file.
    name: "LoadingIndicatorSvg",
    // eslint-disable-next-line sort-keys-fix/sort-keys-fix
    aspectRatio: 1,
    variants: {
      variant: {
        danger: {
          height: "$button.danger.iconSize"
        },
        discreet: {
          height: "$button.discreet.iconSize"
        },
        primary: {
          height: "$button.primary.iconSize"
        },
        secondary: {
          height: "$button.secondary.iconSize"
        },
        tertiary: {
          height: "$button.tertiary.iconSize"
        }
      }
    },
    viewBox: `${VIEWBOX_BOUNDS / 2} ${VIEWBOX_BOUNDS / 2} ${VIEWBOX_BOUNDS} ${VIEWBOX_BOUNDS}`
  }),
  Circle = styled(LibSvg.Circle, {
    cx: VIEWBOX_BOUNDS,
    cy: VIEWBOX_BOUNDS,
    fill: "none",
    name: "LoadingIndicatorCircle",
    r: (VIEWBOX_BOUNDS - STROKE_WIDTH) / 2 - 1,
    stroke: "currentColor",
    strokeWidth: STROKE_WIDTH
  });
function LoadingIndicator({
  variant
}) {
  return /* @__PURE__ */jsx(Svg, {
    variant,
    children: /* @__PURE__ */jsx(Circle, {})
  });
}
export { LoadingIndicator };
//# sourceMappingURL=Button.LoadingIndicator.web.mjs.map
